import type { Channel } from 'stream-chat';

const getOtherParticipantsFullNames = (
  channel: Channel,
  currentUserId: string,
) => {
  if (!channel.state?.members) return '';
  return Object.values(channel.state.members)
    .filter(member => member.user.id !== currentUserId)
    .map(member => member.user.name)
    .join(', ');
};

export default getOtherParticipantsFullNames;
